<template>
  <div class="modal" :class="activeClass">
    <transition
      name="custom-classes-transition"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <div
        class="modal__overlay"
        @click.prevent.stop="handleClick"
        v-show="animate"
      />
    </transition>
    <div class="modal__inner">
      <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeIn delay-animation-600"
        leave-active-class="animated fadeOut"
      >
        <a
          href="#"
          class="modal__close"
          @click.prevent.stop="handleClick"
          v-show="animate"
        >
          <span></span>
          <span></span>
        </a>
      </transition>
      <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeInUp delay-animation-500"
        leave-active-class="animated fadeOutUp"
      >
        <div class="modal__content" v-show="animate">
          <img :src="currentImage.url" :alt="currentImage.alt" v-if="currentImage.url">
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { wait } from '@modules/time'
export default {
  name: 'TheModal',
  props: {
    active: Boolean
  },
  data () {
    return {
      animate: false
    }
  },
  computed: {
    ...mapState('modals', [
      'currentImage'
    ]),
    activeClass () {
      return this.active ? 'is-active' : ''
    }
  },
  watch: {
    active () {
      if (this.active) {
        wait(100, () => {
          this.animate = this.active
        })
      }
    }
  },
  methods: {
    ...mapActions('modals', [
      'updateCurrentImage',
      'updateShowImage'
    ]),
    handleClick () {
      this.animate = false
      wait(500, () => {
        this.updateShowImage(false)
        this.updateCurrentImage({ url: '', alt: '' })
      })
    }
  }
}
</script>

<style lang="scss">
.modal{
  @include media("small-medium"){
    padding-top: layout("spacing")*2;
    padding-bottom: layout("spacing")*2;
  }
  @include media("large"){
    padding-top: layout("spacing")*3;
    padding-bottom: layout("spacing")*3;
  }

  width: 100%;
  height: 100vh;

  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  overflow-y: auto;

  // Overlay

  &__overlay{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    background-color: rgba(black, 0.9);
  }

  // Inner

  &__inner{
    @include media("large"){
      max-width: 80rem;
    }

    position: relative;
    width: 100%;
    min-height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
  }

  // Close

  &__close{
    @include size(2.8rem);
    @include add-transition;
    @include media("small-medium"){
      top: - 4rem;
      right: 2rem;
    }
    @include media("large"){
      top: 0;
      right: - layout("spacing")*2;
    }
    @include hover{
      transform: rotate(180deg);
    }
    position: absolute;
    display: block;
    background-color: transparent;
    padding: 2rem;
    transform-origin: 50% 50%;

    span{
      @include absolute-center;

      display: block;
      height: 2px;
      width: 80%;
      pointer-events: none;
      background-color: white;
      transform-origin: 50% 50%;

      &:first-of-type{
        transform: translateX(-1.6rem) translateY(-0.2rem) rotate(45deg);
      }

      &:last-of-type{
        transform: translateX(-1.6rem) translateY(-0.2rem) rotate(-45deg);
      }
    }
  }

  // Content

  &__content{
    @include media("small-medium"){
      padding: 0 layout("spacing");
    }

    width: 100%;
    margin: 0 auto;

    img{
      width: 100%;
    }
  }
}
</style>
